// About.js

import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
        <div class="contentView">
          <h3>Online Rentals</h3>
          <p>Email <a href="mailto:ice@beisekerhockey.ca">ice@beisekerhockey.ca</a> for inquiries</p>

          <h3>Ice Rental Rates</h3>
          <p>Standard Rental rate: $150/hour (as of September 2022)</p>
          <div>
          <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
          </div>
        </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js